import React from 'react'
import {get, find, debounce} from 'lodash'
import { format } from 'date-fns'
import { trackEvent, getPlaySourcePrefix, } from '~/tools/analytics/cleverTap'
import formatVideoDuration from '~/tools/formatVidDuration'
import { ellipsifyByWord } from '~/tools/strings/ellipsify'
import SharePopup from '~/views/Share/events'
import PersonItem from '~/components/PersonItem'
import { getUser } from '~/redux/user/helpers'
import { getVideoInfo, addToQueue, removeFromQueue } from '~/redux/uservideo/helpers'
import {
  displayDetailsOnBottom,
  displayCategoryItems
} from './helpers'
import { PlayIconLarge } from '~/assets/svg'
import Badge from "~/elements/Tray/Badge";

class NetflixTrayItem extends React.Component {
  constructor(props) {
    super(props)

    this.handleHover = this.handleHover.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleFocus = this.handleFocus.bind(this)
    this.handleShareToggleClick = this.handleShareToggleClick.bind(this)
    this.removeFromQueue = this.removeFromQueue.bind(this)
    this.addToQueue = this.addToQueue.bind(this)

    this.state = {
      hoverOverflow: false,
      isFocused: false
    }
  }

  get thumbnailImage() {
    var w = this.props.maxWidth || 400
    var gist = this.props.item.gist
    var url = this.props.thumbnailType === 'portrait'
      ? get(gist, 'imageGist["_9x16"]') || gist.posterImageUrl || get(gist.posterImage, 'url') || get(this.props.item.images, '_3x4Image.secureUrl') || get(this.props.item.images, '_3x4Image.secureUrl') || get(gist, 'imageGist["_3x4"]') || get(window.settings, 'images.placeholderPoster')
      : gist.videoImageUrl || get(gist.videoImage, 'url') || get(gist, 'landscapeImageUrl') || get(this.props.item.images, '_16x9Image.secureUrl') || get(gist, 'imageGist["_16x9"]') || get(window.settings, 'images.placeholderCover')
    if (this.props.thumbnailType === 'portrait') {
      return `${url}?impolicy=resize&w=${w}&h=${w * 1.78}`
    } else {
      return `${url}?impolicy=resize&w=${w}&h=${w * .5625}`
    }
  }

  get lowQualityImage() {
    var gist = this.props.item.gist
    var url = this.props.thumbnailType === 'portrait'
      ? get(gist, 'imageGist["_9x16"]') || gist.posterImageUrl || get(gist.posterImage, 'url') || get(window.settings, 'images.placeholderPoster')
      : gist.videoImageUrl || get(gist.videoImage, 'url') || get(gist, 'landscapeImageUrl') || get(gist, 'imageGist["_16x9"]') || get(window.settings, 'images.placeholderCover')
    return `${url}?impolicy=resize&w=20&h=20`
  }

  get metaData() {
    const gist = get(this.props, 'item.gist')
    const metaData = get(window.settings, 'brand.metadata')
    if (!gist) return

    return (
      <div className="metadata">
        {metaData && metaData.displayDuration && gist.runtime &&
          <span>{formatVideoDuration(gist.runtime)}</span>
        }
        {metaData && metaData.displayAuthor && gist.author &&
          <span>{gist.author}</span>
        }
        {metaData && metaData.displayPublishDate && gist.publishDate &&
          <span>{format(gist.publishDate, 'MMM D')}</span>
        }
        {
          gist.contentType === 'IMAGE' && this.props.item.streamingInfo && this.props.item.streamingInfo.photogalleryAssets.length > 0 &&
          <span><ion className="ion-camera" /> {this.props.item.streamingInfo.photogalleryAssets.length} Photos</span>
        }
      </div>
    )
  }

  handleHover() {
    var bb = this.el.getBoundingClientRect()
    var cw = window.document.body.clientWidth
    this.setState({ hoverOverflow: (cw < bb.right + bb.width) })
    setTimeout(_ => this.fetchUserData(), 0)
  }

  handleClick(event) {
    this.props.isEpisode
      ? this.props.openEpisodeOverlay(event, this.props.index, this.props.season)
      : this.clearSession()
  }

  handleFocus(e) {
    e.persist()
    setTimeout(() => {
      e.currentTarget && e.currentTarget.focus()
      this.props.onFocus(this.props.index)
    }, 500)
  }

  render() {
    var { item } = this.props
    var gist = item.gist
    const showInfoHover = this.props.infoHover
    const equipment = [];
    const duration = find(item.tags, item => item.tagType === 'classDuration');
    const watchedPercentage = gist.watchedPercentage || 0;
    const categoryTags = displayCategoryItems(item, this.props.onlyPrimaryCategory);
    const aspectRatio = this.props.aspectRatio ? `${this.props.aspectRatio}%` : null;

    item.tags && item.tags.forEach((item) => {
      if (item.tagType === 'equipment') {
        equipment.push(item.title);
      }
    })
    if (gist.contentType === 'PERSON') {
      return (<PersonItem
        {...this.props}
        item={item}
        thumbnailImage={this.thumbnailImage}
        lowQualityImage={this.lowQualityImage}
      />)
    } else if (gist.contentType === 'SEASON_PASS') {
      return (
        <a className="video-tray-item" onClick={this.handleClick}>
          <div className="image-and-details" style={{ backgroundColor: gist.background }}>
            <div className="title-overlay">
              <span>{gist.title}</span>
              <div className="purchase-season-cta cta">
                {gist.cta}
              </div>
            </div>
          </div>
        </a>
      )
    } else {
      return <div className="tray-item" data-index={this.props.index} onMouseEnter={(!this.props.noHover && showInfoHover) ? this.hoverOver : undefined} onMouseLeave={this.mouseLeave}>
        <a className={`video-tray-item ${this.state.hoverOverflow ? "overflow" : ""} ${this.props.thumbnailType}`} href={gist.permalink} ref={el => (this.el = el)} onClick={this.handleClick} onFocus={this.handleFocus} onMouseEnter={this.handleHover}>
          <div className="image-and-details" style={aspectRatio && { paddingTop: aspectRatio }}>
            {this.metaData}
            {!this.props.noBadgeImage &&
              <Badge item={item} thumbnailType={this.props.thumbnailType} />}
            <div className="image">
              <img src={this.props.clickNext || !this.props.lazyLoad ? this.thumbnailImage : this.lowQualityImage} alt={gist.title} className="lazy" data-src={this.thumbnailImage} />
              {gist.contentType !== 'PERSON' && !this.props.hideCategories && <div className="details">
                {duration && <div className="duration item">
                  {duration.title}
                </div>}
                {gist.primaryCategory && gist.primaryCategory.title &&
                  categoryTags.map(e => (
                    <div key={e} className="detail_item">
                      {e}
                    </div>
                  ))}
              </div>}
              {(!this.props.noHover && showInfoHover && gist.contentType !== 'PERSON') && <div className="hover-details">
                {gist.scheduleStartDate && <div className="day">
                  {format(gist.scheduleStartDate, "dddd h:mm A")}
                </div>}
                {gist.description && <div className="desc">
                  {ellipsifyByWord(gist.description, 20, 10)}
                </div>}

                {equipment.length > 0 && <div className="tag-list">
                  <p className="equipment-title">
                    SET-UP
                    </p>
                  <p className="equipments">{equipment.join(',')}</p>
                </div>}
              </div>}
            </div>
            {gist.scheduleStartDate && <div className="event-time">
              {format(gist.scheduleStartDate, "h:mm A")}
            </div>}
            {this.props.showProgressBar && watchedPercentage > 0 && <progress value={watchedPercentage} max="100"></progress>}
            {this.props.showPlayIcon && <PlayIconLarge className="playIconLarge" />}
          </div>
        </a>
        {this.props.showDetailsBottom && displayDetailsOnBottom(duration, gist)}
      </div>;
    }
  }

  hoverOver = (e) => {
    e.persist()
    debounce((e) => {
      let scale = 1.25;
      if (window.outerWidth > 1025) {
        const target = e.target.closest(".tray-item");
        const parent = target.parentElement;
        const index = target.dataset.index;
        parent.style.transform = `scale(${scale})`;
        if (parent.nextSibling === null && parent.previousSibling === null) {
          return;
        }
        if (parent.nextSibling === null || (parseInt(index, 10) + 1) % this.props.slidesToScroll === 0) {
          parent.classList.add("overflow");
          Array.from(parent.parentElement.children).forEach(
            function (node) {
              if (parseInt(node.dataset.index, 10) < index) {
                node.style.transform = `translate3d(-${node.clientWidth *
                  (scale - 1)}px, 0, 0)`;
              }
            }
          );
          return;
        }
        Array.from(parent.parentElement.children).forEach(function (node) {
          if (parseInt(node.dataset.index, 10) > index) {
            node.style.transform = `translate3d(${node.clientWidth * (scale - 1)}px, 0, 0)`;
          }
        });
      }
    }, 100)(e)
  }

  mouseLeave(e) {
    e.persist()
    debounce((e) => {
      const target = e.target.closest('.tray-item');
      Array.from(target.parentElement.parentElement.children).forEach(function (node) {
        node.classList.remove('overflow')
        node.style.transform = `translate3d(0, 0, 0)`
      });
    }, 100)(e)
  }

  handleShareToggleClick(event) {
    event.preventDefault()
    const shareOptions = {
      position: event.currentTarget.getBoundingClientRect(),
      data: this.props.item.gist
    }
    SharePopup.open(shareOptions)
  }

  clearSession() {
    //clearing the session for the autoplay to reinitiate to new set of videos
    window.sessionStorage.removeItem('rvid')
  }

  fetchUserData() {
    var id = this.props.item.gist.id
    getUser(user => {
      if (!user) {
        this.setState({ userData: null })
        return
      }
      getVideoInfo(id, data => {
        this.setState({ userData: data })
      })
    })
  }

  addToQueue() {
    const { gist = {}, creditBlocks = [] } = this.props.item
    const id = gist.id
    const contentType = gist.contentType

    addToQueue(id, contentType, data => {
      var addToQueueEventData = {
        contentId: gist.id,
        contentTitle: gist.title,
        contentType: gist.contentType,
        playbackType: 'Streamed',
        networkType : window.navigator.connection ? (window.navigator.connection.type ? window.navigator.connection.type : window.navigator.connection.effectiveType) : "wifi" ,
        PlaySource: getPlaySourcePrefix(),
        showName: gist.title,
        platform: 'Web',
      }
      creditBlocks.forEach(creditBlock => {
        if (creditBlock.title.trim() === 'Director') {
          addToQueueEventData.directorName = creditBlock.credits.length > 0 ? creditBlock.credits.map(it => it.title).join(',') : ''
        }
        if (creditBlock.title.trim() === 'Starring') {
          addToQueueEventData.actorName = creditBlock.credits.length > 0 ? creditBlock.credits.map(it => it.title).join(',') : ''
        }
      })
      trackEvent('Added to Watchlist', addToQueueEventData)
      this.setState({ isQueued: true })
    })
  }

  removeFromQueue() {
    const { gist = {}, creditBlocks = [] } = this.props.item
    const id = gist.id

    removeFromQueue(id, data => {
      var removeFromQueueEventData = {
        contentId: gist.id,
        contentTitle: gist.title,
        contentType: gist.contentType,
        playbackType: 'Streamed',
        networkType : window.navigator.connection ? (window.navigator.connection.type ? window.navigator.connection.type : window.navigator.connection.effectiveType) : "wifi" ,
        PlaySource: getPlaySourcePrefix(),
        showName: gist.title,
        platform: 'Web',
      }
      creditBlocks.forEach(creditBlock => {
        if (creditBlock.title.trim() === 'Director') {
          removeFromQueueEventData.directorName = creditBlock.credits.length > 0 ? creditBlock.credits.map(it => it.title).join(',') : ''
        }
        if (creditBlock.title.trim() === 'Starring') {
          removeFromQueueEventData.actorName = creditBlock.credits.length > 0 ? creditBlock.credits.map(it => it.title).join(',') : ''
        }
      })
      trackEvent('Removed From Watchlist', removeFromQueueEventData)
      this.setState({ isQueued: false })
    })
  }
}

export default NetflixTrayItem;